var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "188.65 557.056 320.854 118.835",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsvectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud2"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 118.835,
    width: 320.854,
    x: 188.65,
    y: 557.056
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud2)",
    id: "Layer",
    vectornatorlayername: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.504 580.262L509.504 580.262C509.504 567.446 499.115 557.056 486.299 557.056L234.22 557.056C221.404 557.056 211.015 567.445 211.015 580.261L211.015 580.261C211.015 593.077 221.404 603.466 234.22 603.466L282.621 603.466C292.099 603.466 299.782 611.149 299.782 620.627L299.782 620.627C299.782 630.105 292.099 637.788 282.621 637.788L207.702 637.788C197.18 637.788 188.65 646.318 188.65 656.84L188.65 656.84C188.65 667.362 197.18 675.891 207.702 675.891L454.583 675.891C465.105 675.891 473.635 667.361 473.635 656.84L473.635 656.84C473.635 646.318 465.105 637.788 454.583 637.788L430.56 637.788C421.082 637.788 413.399 630.105 413.399 620.627L413.399 620.627C413.399 611.149 421.082 603.466 430.56 603.466L486.299 603.466C499.114 603.467 509.504 593.078 509.504 580.262Z",
    fill: "#a9b3c1",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/Cloud2.5ceaa9b90961b75045262124b98e8433.svg";
export { ForwardRef as ReactComponent };